import { createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const cryptoAPIHeaders = {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '23776a1dadmsh42fb6a19e357b71p1d3a47jsnad58cb5c1166'

}

const baseUrl = 'https://coinranking1.p.rapidapi.com';

const createRequest = (url) => ({ url, headers: cryptoAPIHeaders });


export const cryptoApi = createApi({
    reducerPath: 'cryptoApi',
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        getCryptos : builder.query({
            query : (count) => createRequest(`/coins?limit=${count}`),
        }),
        getCryptoDetails : builder.query({
            query : (coinID) => createRequest(`/coin/${coinID}`),
        }),
        getCryptoHistory : builder.query({
            query : ({coinId, timePeriod}) => createRequest(`/coin/${coinId}/history?timeperiod=${timePeriod}`),
        }),
        getExchanges : builder.query({
            query : (count) => createRequest(`/exchanges?limit=${count}`),
        })

    })
});

export const {
    useGetCryptosQuery, useGetCryptoDetailsQuery, useGetCryptoHistoryQuery, useGetExchangesQuery
} = cryptoApi;